import { initializeApollo as originalInitializeApollo } from '@firsttable/apollo-client';
import type { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { logoutUser } from './handlers';
import {
  NEXT_PUBLIC_GRAPHQL_BUILD_ENDPOINT,
  NEXT_PUBLIC_GRAPHQL_ENDPOINT,
  NEXT_PUBLIC_GRAPHQL_MUTATION_ENDPOINT,
} from '../env';

const initializeApollo = (
  initialApolloState = null,
  preview = false,
  bypassCache = false
): ApolloClient<NormalizedCacheObject> => {
  // If it's server side and not in preview mode, use build endpoint which should be configured to GraphCDN
  // If it's client side, or in preview mode, use the direct endpoint
  const endpoint =
    typeof window === 'undefined' && !preview
      ? NEXT_PUBLIC_GRAPHQL_BUILD_ENDPOINT
      : NEXT_PUBLIC_GRAPHQL_ENDPOINT;

  return originalInitializeApollo(initialApolloState, {
    key: typeof window === 'undefined' ? 'SERVER' : 'CLIENT',
    endpoint,
    mutationEndpoint: NEXT_PUBLIC_GRAPHQL_MUTATION_ENDPOINT,
    handlers: {
      logoutHandler: logoutUser,
    },
    preview,
    bypassCache,
  });
};

export { initializeApollo, logoutUser };
